module.exports = __webpack_public_path__ + "img/drink.d55f21ea.png";